<template>
  <div class="news-detail">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-alert type="warning" border="left" colored-border>
            ※記事の印刷及びスクリーンショットの取得は禁止です。
          </v-alert>
        </v-col>
        <div v-if="dialogMessage" class="error-message">
          {{ dialogMessage }}
        </div>
        <v-col cols="12">
          <v-textarea
            v-model="news.title"
            label="タイトル"
            readonly
            full-width
            rows="1"
            class="no-resize"
          ></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="news.body"
            label="内容"
            readonly
            full-width
            auto-grow
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn color="primary" @click="navigateAgreementPage(article_id)"
            >営業トーク例作成
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { errorMessages } from '@/constants/errorMessages.js';
import { ref, onMounted } from "vue";
import { fetchNewsDetail, fetchArticleRegionCategory, fetchArticleIndustryCategory } from "@/api";
import { useRouter } from "vue-router";
import { inject } from 'vue';

let gtm = null;

export default {
  props: {
    article_id: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const news = ref({
      title: "",
      content: "",
      url: "",
    });

    const apiNewsData = ref([]);
    const dialogMessage = ref('');
    const router = useRouter();

    // 記事詳細を取得する関数
    const fetchArticleDetails = async (articleId) => {
      try {
        const response = await fetchNewsDetail(articleId);

        // レスポンスが 200 であるときチェックを行う
        if (response.status === 200) {

          // レスポンスにエラーメッセージがあるか
          if (response.data.errno !== undefined && response.data.errno !== "") {
            dialogMessage.value = errorMessages.e01301(response.data.errno, response.status);

          // ない場合は正常なデータである
          } else {
            apiNewsData.value =  response.data;
          }
        } else {
          dialogMessage.value = errorMessages.e01301(response.data.errno, response.status);
        }
      } catch (error) {
        // ネットワークエラーの処理
        dialogMessage.value = errorMessages.e01301("E01301", error.code);
      }

      // タイトルがない場合
      if (!apiNewsData.value.title || apiNewsData.value.title.length == 0) {
        news.value = apiNewsData.value;
        news.value.title = "(タイトルなし)"
      }
      else {
        news.value = apiNewsData.value; // 取得したデータをnewsに設定
      }

      // 本文がない場合
      if (!apiNewsData.value.body || apiNewsData.value.body.length == 0) {
        news.value = apiNewsData.value;
        news.value.body = "(本文なし)"
      }
      else {
        news.value = apiNewsData.value; // 取得したデータをnewsに設定
      }

      // 記事に含まれる <br> タグを \r\n に変換する
      news.value.body = news.value.body.replace(/<br\s*\/?>/gi, '\r\n');
    };

    const navigateAgreementPage = (newsId) => {
      gtm?.sendAiTalkButtonEvent()
      window.open(router.resolve({ name: "UsageAgreement", params: { article_id: newsId } }).href, '_blank');
    };

    const sendGTMInfo = async (articleId) =>{
      const regionsResponse = await fetchArticleRegionCategory(articleId);
      const regions = regionsResponse.data?.regions || [];  // regions配列を取得
      const industriesResponse = await fetchArticleIndustryCategory(articleId);
      const industries = industriesResponse.data?.industries || [];  // industries配列を取得

      // GTM に情報を送信する
      gtm?.sendNewsDetailCategories(industries, regions);
    }

    onMounted(() => {
      fetchArticleDetails(props.article_id);
      gtm = inject('$gtm');
      sendGTMInfo(props.article_id)
    });

    return {
      news,
      navigateAgreementPage,
      dialogMessage,
      sendGTMInfo,
    };
  },
  methods: {

  },
};
</script>

<style scoped>
.news-detail {
  /* max-width: 800px; */
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.no-resize ::v-deep textarea {
  resize: none;
}

.text-center {
  text-align: center;
}

.v-btn {
  margin-top: 20px;
}

/* -----------------------------------エラーメッセージ部分----------------------------------- */
.error-message {
  color: red;
  text-align: center;
  margin: 10px 0;
  padding: 10px;
  font-weight: bold;
}

</style>

